import React from 'react';

const Speciality02 = () => {
    return (
        <div className="features bg_image_3 jarallax">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <div className="featurebox">
                            <div className="featurebox_wrapper">
                                <div className="featurebox_icon">
                                    <img className="primary_img" src="images/about/icon1.png" alt="icon" />
                                </div>
                                <div className="featurebox_content">
                                    <h6>Finest Chef</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="featurebox">
                            <div className="featurebox_wrapper">
                                <div className="featurebox_icon">
                                    <img className="primary_img" src="images/about/icon2.png" alt="icon" />
                                </div>
                                <div className="featurebox_content">
                                    <h6>Beautiful Ambience</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="featurebox">
                            <div className="featurebox_wrapper">
                                <div className="featurebox_icon">
                                    <img className="primary_img" src="images/about/icon3.png" alt="icon" />
                                </div>
                                <div className="featurebox_content">
                                    <h6>Safe Food Takeout</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="featurebox">
                            <div className="featurebox_wrapper">
                                <div className="featurebox_icon">
                                    <img className="primary_img" src="images/about/icon4.png" alt="icon" />
                                </div>
                                <div className="featurebox_content">
                                    <h6>Famous Cousine</h6>
                                    <p>Lorem ipsum dolor sit amet consectetur adipiscing elittempor incididu labore dolore</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Speciality02;